/**
 * OAuth Service - Handles API interactions for OAuth authentication
 */

import { post, get } from "../utils/apiUtils";

// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_authentication/oauth`;

/**
 * Get all claims Oauths
 * @param {any} domainName - Fetch for what domain
 * @returns {Promise<Object>} Promise resolving to Oauth listing
 */
export const fetchOAuthConfigs = async (domainName) => {
  try {
    localStorage.setItem('domainName', domainName);
    const response = await get(`${API_URL}/configs/domain?domainName=${domainName}`);
    return response || []; // Ensure we always return an array
  } catch (error) {
    console.error('Error fetching Claims:', error);
    throw error;
  }
};

/**
 * Get all Entities bases with optional filtering
 * @param {Object} code - Filter parameters
 * @param {Object} state - Sort parameters
 * @param {Object} provider - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const processOAuthCallback = async (code, state, provider, applicationId, applicationSource,domainName,server_name) => {
  try {
    const response = await post(`${API_URL}/callback`, 
      {
        code,
        state,
        provider,
        domainName,
        server_name
      },
      {
        headers: {
          'X-Application-ID': applicationId,
          'X-Application-Source': applicationSource,
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};





export default {
  fetchOAuthConfigs,
  processOAuthCallback
};
